var React = require('react');

function CloseMessageIcon (props) {
    return React.createElement("svg",props,[React.createElement("line",{"y1":"-0.733334","x2":"14.6667","y2":"-0.733334","transform":"matrix(0.707107 0.707107 -0.657201 0.753715 0.815186 2)","strokeWidth":"1.46667","key":0}),React.createElement("line",{"y1":"-0.733334","x2":"14.6667","y2":"-0.733334","transform":"matrix(-0.707107 0.707107 0.657201 0.753715 12.1848 2)","strokeWidth":"1.46667","key":1})]);
}

CloseMessageIcon.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13"};

module.exports = CloseMessageIcon;

CloseMessageIcon.default = CloseMessageIcon;
